var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9229 10.1855H13.9998C13.7537 10.1855 13.5383 10.4317 13.5383 10.6471V13.724C13.5383 13.9701 13.3229 14.1855 13.0768 14.1855H2.92293C2.67677 14.1855 2.46139 13.9701 2.46139 13.724V10.6471C2.46139 10.4317 2.246 10.1855 1.99985 10.1855H1.07677C0.830619 10.1855 0.615234 10.4317 0.615234 10.6471V14.8009C0.615234 15.4778 1.16908 16.0317 1.846 16.0317H14.1537C14.8306 16.0317 15.3845 15.4778 15.3845 14.8009V10.6471C15.3845 10.4317 15.1691 10.1855 14.9229 10.1855ZM8.30754 1.38553C8.12293 1.20092 7.846 1.20092 7.66139 1.38553L3.50754 5.53938C3.32293 5.72399 3.32293 6.00092 3.50754 6.18553L4.1537 6.83169C4.33831 7.0163 4.61523 7.0163 4.79985 6.83169L6.52293 5.10861C6.70754 4.92399 7.07677 5.04707 7.07677 5.32399V11.8471C7.07677 12.0932 7.26139 12.3086 7.50754 12.3086H8.43062C8.67677 12.3086 8.92293 12.0625 8.92293 11.8471V5.35476C8.92293 5.07784 9.23062 4.95476 9.446 5.13938L11.1691 6.86246C11.3537 7.04707 11.6306 7.04707 11.8152 6.86246L12.4614 6.2163C12.646 6.03169 12.646 5.75476 12.4614 5.57015L8.30754 1.38553Z",
    fill: "#28519E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBadgeIcon);
export default __webpack_public_path__ + "static/media/uploadBadgeIcon.524a69f476616694f787867d8ee7cb13.svg";
export { ForwardRef as ReactComponent };